/*
 * Copyright (c) 2017 Ytica.com a.s. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

const BASE_URL = '/'
const SSO_URL = 'https://identity.ytica.com'
const SSO_API_URL = 'https://identity.ytica.com/identity'

export {
  BASE_URL,
  SSO_URL,
  SSO_API_URL
}



// WEBPACK FOOTER //
// ./ext/env-config.js